import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

const categoryImages: Record<string, string> = {
  entertainment: "https://readdy.ai/api/search-image?query=Chinese%20entertainment%20gossip%20news%20magazine%20cover%20style%20with%20bold%20typography%20and%20dramatic%20lighting%2C%20warm%20red%20and%20orange%20tones%2C%20editorial%20design%2C%20modern%20layout%2C%20celebrity%20silhouette&width=800&height=500&seq=cat-entertainment&orientation=landscape",
  influencer: "https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20setup%20with%20colorful%20ring%20lights%20and%20smartphone%20on%20tripod%2C%20modern%20social%20media%20aesthetic%2C%20warm%20neon%20tones%2C%20influencer%20culture%20vibe%2C%20digital%20creator%20workspace&width=800&height=500&seq=cat-influencer&orientation=landscape",
  social: "https://readdy.ai/api/search-image?query=Urban%20city%20street%20scene%20with%20crowd%20of%20people%20and%20digital%20billboards%2C%20breaking%20news%20vibe%2C%20warm%20golden%20hour%20lighting%2C%20social%20media%20trends%20concept%2C%20modern%20metropolitan%20photography&width=800&height=500&seq=cat-social&orientation=landscape",
  positive: "https://readdy.ai/api/search-image?query=Warm%20sunlight%20through%20window%20with%20gentle%20curtains%20blowing%2C%20cozy%20peaceful%20interior%2C%20golden%20hour%20glow%2C%20positive%20energy%20concept%2C%20soft%20warm%20tones%2C%20hopeful%20atmosphere%2C%20minimal%20style&width=800&height=500&seq=cat-positive&orientation=landscape",
  funny: "https://readdy.ai/api/search-image?query=Bright%20colorful%20comedy%20stage%20with%20spotlights%20and%20confetti%2C%20fun%20entertainment%20atmosphere%2C%20warm%20vibrant%20colors%2C%20humor%20and%20laughter%20concept%2C%20festive%20celebration%20vibe%2C%20playful%20composition&width=800&height=500&seq=cat-funny&orientation=landscape",
};

const tagStyles: Record<string, string> = {
  entertainment: "bg-primary-100 text-primary-700",
  influencer: "bg-accent-100 text-accent-700",
  social: "bg-secondary-100 text-secondary-700",
  positive: "bg-primary-100 text-primary-700",
  funny: "bg-accent-100 text-accent-700",
};

export default function CategoryNav() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end gap-4 mb-12 md:mb-16">
          <div className="lg:w-2/5">
            <div className="flex items-center gap-3 mb-3">
              <span className="w-1.5 h-5 bg-secondary-500 rounded-full"></span>
              <span className="text-secondary-600 text-sm font-medium tracking-wider">CATEGORIES</span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 tracking-tight leading-tight">
              吃瓜分类
              <br />
              导航
            </h2>
          </div>
          <div className="lg:w-3/5">
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed">
              按分类快速找到你想吃的瓜。娱乐圈八卦、网红圈黑料、社会热点追踪、独家深度爆料——六大频道全面覆盖，总有一款适合你。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <Link
            to={`/category/${categories[3].slug}`}
            className="group relative rounded-2xl overflow-hidden aspect-[3/4] md:row-span-2 md:aspect-auto cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20investigation%20scene%20with%20magnifying%20glass%20and%20documents%20on%20wooden%20desk%2C%20warm%20dramatic%20lighting%2C%20film%20noir%20style%2C%20detective%20vibe%2C%20shadows%2C%20exclusive%20scoop%20concept%2C%20cinematic%20composition&width=800&height=1200&seq=cat-exclusive-big&orientation=portrait"
              alt={categories[3].name}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <h3 className="font-heading text-2xl md:text-3xl font-black text-white mb-2">{categories[3].name}</h3>
              <p className="text-white/70 text-sm">{categories[3].description}</p>
            </div>
          </Link>

          {categories.filter((_, i) => i !== 3).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:bg-background-200/70 transition-colors"
            >
              <div className="p-6">
                <div className="flex items-center gap-2 mb-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${tagStyles[cat.slug] || "bg-secondary-100 text-secondary-700"}`}>
                    <i className={`${cat.icon} mr-1`}></i>
                    {cat.name}
                  </span>
                </div>
                <div className="aspect-[16/10] rounded-xl overflow-hidden mb-4">
                  <img
                    src={categoryImages[cat.slug]}
                    alt={cat.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <h3 className="font-heading text-xl font-bold text-foreground-950 mb-2">{cat.name}</h3>
                <p className="text-foreground-500 text-xs md:text-sm">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}